import { Suspense, lazy } from 'react';
import { useUIStore } from '@/store/uiStore';

// T3108: okno preizkusa modula (s skladom Radix Dialog) se naloži šele, ko ga nekdo odpre.
const ModuleTrialModal = lazy(() => import('./ModuleTrialModal'));

export default function LazyModuleTrialModal() {
  const isOpen = useUIStore((s) => s.isModuleTrialModalOpen);
  if (!isOpen) return null;
  return (
    <Suspense fallback={null}>
      <ModuleTrialModal />
    </Suspense>
  );
}
